import React from 'react';
import {Form} from 'react-bootstrap';
import './../assets/css/create-task.css';
import axios from 'axios';


export default class CreateTask extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            title: '',
            description: '',
            priority: 1,
            message: false
        };
    }

    postTask(){
        if(this.state.title.length == 0){
            alert('title cant be empty.')
            return;
        }

        let newTask = {
            title: this.state.title,
            description: this.state.description,
            priority: this.state.priority
        };

        axios.post('https://task-app-server-jatin.herokuapp.com/tasks', newTask)
            .then(res => {
                this.setState({
                    title: '',
                    description: '',
                    priority: 1,
                    message: true
                });
            })
            .catch((err) => {
                console.log(err)
            });
    }

    render(){
        return (
            <div className="Form-Box">
                <div className="field">
                    <label className="label">Title</label>
                    <div className="control">
                        <input 
                            className="input" 
                            type="text" 
                            placeholder="e.g Learn cooking"
                            value = {this.state.title}
                            onChange={(e) => this.setState({title: e.target.value})}
                        />
                    </div>
                </div>

                <div className="field">
                    <label className="label">Decsription</label>
                    <textarea 
                        className="textarea is-small" 
                        placeholder="e.g Prepare a dish..."
                        value = {this.state.description}
                        onChange={(e) => this.setState({description: e.target.value})}  
                    />
                </div>

                <div className="field">
                    <div className="control">
                        <label className="label">Priority (5-Highest 1-Lowest)</label>
                        <div className="select">
                            <select 
                                value = {this.state.priority}
                                onChange={(e) => this.setState({priority: e.target.value})}
                            >
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>
                    </div>
                </div> 
                
                <div className="field">
                    <button className="button is-primary" onClick={() => this.postTask()}>Add Task</button>  
                </div>

                <div className="field">
                    {(this.state.message)? "Task added succesfully!": null}
                </div>
            </div>
        );
    }
}